<template>
  <div class="export-container" v-if="initializing">
    <p>Filtered by:</p>
    <p>{{ clientNameExport }}</p>
    <div class="export-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" class="export-button" @click="startExporting"> Export </mds-button>
    </div>
  </div>
  <div class="export-container" v-else-if="exporting">
    <mds-loader />
    <p class="export-process-text">Loading</p>
    <button class="mds-button" type="button" @click="abortExport">
      Cancel
    </button>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import FileSaver from 'file-saver';
import b64toBlob from 'b64-to-blob';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { exportPendingFundsData } from '@/services/Export';

export default {
  name: 'export-pending-data',
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    startExporting() {
      this.exporting = true;
      this.initializing = false;

      exportPendingFundsData({
        fiduciaryNumber: this.fiduciaryNumber,
        clientNumber: this.clientNumber,
      }).then((response) => {
        const { data } = response;
        const blob = b64toBlob(data.file, data.type);
        FileSaver.saveAs(blob, this.fileName);
        this.closeModal();
        this.$store.dispatch('openNotification', {
          message: `${this.fileName} is ready`,
        });
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      });
    },
    abortExport() {
      this.controller.abort();
      this.closeModal();
    },
  },
  computed: {
    ...mapState({
      clientName: (state) => state.pending.client.name,
      clientNumber: (state) => state.pending.client.selected,
      fiduciaryNumber: (state) => state.user.fiduciary.id,
      fiduciaryName: (state) => state.user.fiduciary.name,
    }),
    fileName() {
      let name = this.fiduciaryName;
      if (this.clientNumber !== 0) {
        name += ` ${this.clientName}`;
      }
      name += ' Pending Fund Changes ';
      const d = new Date();
      name
        += String(d.getFullYear())
        + String(d.getMonth() + 1)
        + String(d.getDate())
        + String(d.getHours())
        + String(d.getMinutes())
        + String(`${d.getSeconds()}.xlsx`);
      return name;
    },
    clientNameExport() {
      if (this.clientNumber === 0) {
        return 'All Clients';
      }
      return `Client: ${this.clientName}`;
    },
  },
  data() {
    return {
      initializing: true,
      exporting: false,
      exported: false,
      controller: new AbortController(),
    };
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<style lang="scss">
.export-container {
  @include mds-body-text-m();
  .export-process-text {
    text-align: center;
    @include mds-body-text-l();
  }
  .export-actions {
    text-align: right;
    @include fc-buttons-list();
  }
}
</style>
